import { render } from "./TokenLieBiaoPage.vue?vue&type=template&id=cf2044b0"
import script from "./TokenLieBiaoPage.vue?vue&type=script&lang=js"
export * from "./TokenLieBiaoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__